//components
import { BasicButton, CancelConfirmModal, LoadingSpinner, ToastMessage } from 'thrive-components';
import LegacyAppUsers from  '@/components/modals/orgSettings/Passkeys/LegacyAppUsers';
import PasskeySettings from  '@/components/elements/orgSettings/passkeys/PasskeySettings';
import PasskeySettingsExplainer from  '@/components/elements/orgSettings/passkeys/PasskeySettingsExplainer';
import PasskeySetUpNeededPanel from  '@/components/elements/orgSettings/passkeys/PasskeySetUpNeededPanel';

//hooks
import UsePasskeySettingsScreen from './PasskeySettingsScreen.hooks'

//styling
import "../../../../css/orgSettings/passkeys/passkey-settings-screen.scss"



const PasskeySettingsScreen = ({orgId} : {orgId: string}) => {  
    const {
        isLoading,
        showModal,
        setShowModal,
        userCountInfo,
        forcePasskeySignIn,
        notificationDetails,
        setForcePasskeySignIn,
        passkeysEnabled,
        onEnablePasskeysClick,
        onSaveChangesClick,
        showConfirmationModal,
        setShowConfirmationModal,
        restrictedAccess,
        closeToast
    } = UsePasskeySettingsScreen(orgId);

    return(
        <div className="passkey-settings-screen" data-testid="passkey-settings-screen">
            <PasskeySettingsExplainer />

            {isLoading 
                ?   <div className="loading-passkey-settings-panel">
                        <LoadingSpinner size={10} />
                    </div>
            
                :   <>
                    {   restrictedAccess
                        ?   <PasskeySetUpNeededPanel />

                        :   <PasskeySettings 
                                userCountInfo={userCountInfo} 
                                setShowModal={setShowModal} 
                                passkeysEnabled={passkeysEnabled} 
                                onEnablePasskeysClick={onEnablePasskeysClick} 
                                forcePasskeySignIn={forcePasskeySignIn} 
                                setForcePasskeySignIn={setForcePasskeySignIn} 
                            />
                    }
                    </>
            }

            <div className='passkeys-button-panel'>
                <BasicButton 
                    isDisabled={restrictedAccess}
                    className='save-changes-button'
                    content={"Save Changes"} 
                    ariaLabel={'Save Changes'} 
                    onButtonClick={()=>onSaveChangesClick(false)}
                />
            </div>

            <LegacyAppUsers
                orgId={orgId} 
                legacyAppUserCount={userCountInfo.legacyAppUserCount}
                totalUserCount={userCountInfo.totalEligibleUsers}
                showModal={showModal} 
                hideModal={()=>setShowModal(false)}
            />

            {showConfirmationModal &&
                <CancelConfirmModal 
                    className='enable-passkey-sign-in-modal'
                    headerContent={"Enable Passkey Sign In"} 
                    bodyContent={"This will enable Passkey sign in for all users. CMS admins must set up their own Passkey before they can manage Passkey settings or recovery requests."} 
                    onCloseClick={() => setShowConfirmationModal(false)} 
                    cancelButtonText={'Cancel'} 
                    cancelButtonAriaLabel={'Cancel and do not save changes'} 
                    confirmButtonText={'Continue'} 
                    confirmButtonAriaLabel={'Continue and save changes'} 
                    onCancelClick={() => setShowConfirmationModal(false)} 
                    onConfirmClick={()=>onSaveChangesClick(true)}
                />
            }

            {notificationDetails && (
                <ToastMessage 
                    showToast={notificationDetails.show}
                    closeToast={closeToast}
                    toastOptions={{
                        type: notificationDetails.status === 'success' ? 'success' : 'error' as any,
                        toastCompletionCallback:  notificationDetails.status === 'success' 
                            ? () => {window.location.reload()}
                            : undefined,
                    }}
                >
                    <span>{notificationDetails.message}</span>
                </ToastMessage>
            )}
        </div>
    )
}

export default PasskeySettingsScreen